import React from 'react';

import LabelField from '../../../components/plain/LabelField';
import FieldString from '../../../components/plain/FieldString';
import FieldEnum from '../../../components/plain/FieldEnum';
import FieldDecimal from '../../../components/plain/FieldDecimal';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';
import KatottgButton from '../../../components/katottgtree/KatottgButton';

import {performApiRequest, KATOTTG_GETPATH_API_URL } from '../../../util/restapi';
import {
	LOCALITY_TYPE_REGION, LOCALITY_TYPE_MEGA, LOCALITY_TYPE_DISTRICT, LOCALITY_TYPE_COMMUNITY,
	LOCALITY_TYPE_CITY, LOCALITY_TYPE_TOWN, LOCALITY_TYPE_VILLAGE, LOCALITY_TYPE_VILLAGE_SMALL, 
	LOCALITY_TYPE_DIVISION
} from '../../../util/consts/common';

class DivLocationList extends React.Component {

	/*
		parentField
		path
		readOnly
		plain
		instance
		ignoreTitle
	*/
	constructor(props) {
		super(props);
	}

	locationCardBuilder = (fieldLocation, index) => {
		let card = '';
		if( fieldLocation.value.place.value )
			card += fieldLocation.value.place.value;
		if( card.length > 40 )
			card = card.substring(0,37) + '...';
		return card;
	}
	buildLocationPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<LocationPanel fieldGroup={fieldGroup} listItemInfo={listItemInfo} 
				instance={instance} plain={plain}  readOnly={readOnly}
			/>
		);
	}

	render() {
		let path = this.props.path;
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		let ignoreTitle = this.props.ignoreTitle;
		return (
			<div>
				<FieldList_CardsPanel path={path} instance={instance} parentField={parentField} plain={plain} 
					buildItemComponent={this.buildLocationPanel} itemCardBuilder={this.locationCardBuilder} 
					labelEmptyToHeader={true} ignoreTitle={ignoreTitle} readOnly={readOnly}
					styles={{
						divMain: {
							padding: '10px 10px 10px 10px',
							backgroundColor: 'rgb(200,200,200)',
							border: '1px solid blue',
							marginTop: '10px',
							marginBottom: '10px'
						},
						divCardsBlock: {
							backgroundColor: 'rgb(200,200,200)',
							minWidth: '250px'
						},
						divCard: {
							marginTop: '3px',
							padding: '7px',
							cursor: 'pointer',
							backgroundColor: 'rgb(230,230,230)',
							minHeight: '18px'
						}
					}}
				/>
			</div>
		);
	}
}

class LocationPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
		readOnly
	*/
	constructor(props) {
		super(props);
	}

	onKatottgSelected = async (code) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.fieldGroup;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		let fieldKatottg = instance.getField('katottg', parentField);
		instance.setFieldValue(fieldKatottg, code);
		let request = {code: code}
		let response = await performApiRequest(KATOTTG_GETPATH_API_URL, request);
		if( ! response.success ) {
			plain.props.app.showResponse( response, 'Katottg error' );
			return;
		}

		let fieldRegion = instance.getField('region', parentField);
		let fieldDistrict = instance.getField('district', parentField);
		let fieldCommunity = instance.getField('community', parentField);
		let fieldCity = instance.getField('city', parentField);
		
		for(let record of response.listKatottgRecord) {
			let category = record.categoryId;
			if( category == LOCALITY_TYPE_REGION || category == LOCALITY_TYPE_MEGA ) {
				let oldValue = fieldRegion.value;
				if( ! oldValue ) {
					let regionCode = record.code.substring(2,7);
					instance.setFieldValue(fieldRegion, regionCode);
				}
				if( category == LOCALITY_TYPE_MEGA ) {
					oldValue = fieldCity.value;
					if( ! oldValue ) {
						instance.setFieldValue(fieldCity, record.name);
					}
				}
			} else if ( category == LOCALITY_TYPE_DISTRICT || category == LOCALITY_TYPE_DIVISION ) {
				let oldValue = fieldDistrict.value;
				if( ! oldValue ) {
					instance.setFieldValue(fieldDistrict, record.name);
				}
			} else if ( category == LOCALITY_TYPE_COMMUNITY ) {
				let oldValue = fieldCommunity.value;
				if( ! oldValue ) {
					instance.setFieldValue(fieldCommunity, record.name);
				}
			} else if ( category == LOCALITY_TYPE_CITY || category == LOCALITY_TYPE_TOWN 
					|| category == LOCALITY_TYPE_VILLAGE || category == LOCALITY_TYPE_VILLAGE_SMALL ) 
			{
				let oldValue = fieldCity.value;
				if( ! oldValue ) {
					instance.setFieldValue(fieldCity, record.name);
				}
			}
			console.log('KATOTTG: ', record);
		}
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.fieldGroup;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{flexGrow: '1', margin: '5px 0 0 0', padding: '10px', backgroundColor: 'rgb(240,240,240)'}}>
				<div style={{padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'role'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', width: '120px', marginRight: '20px'}}}
						/>
						<FieldEnum instance={instance} path={'language'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '3', width: '200px', marginRight: '20px'}}}
						/>
						<FieldString instance={instance} path={'dates'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'country'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {flexGrow: '1', width: '200px', marginRight: '20px'}}}
						/>
						<FieldString instance={instance} path={'index'} parentField={parentField} plain={plain}
							styles={{ input: {width: '60px', marginRight: '20px'} }}
							readOnly={readOnly}
						 />
						<FieldString instance={instance} path={'katottg'} parentField={parentField} plain={plain}
							styles={{ input: {flexGrow: '1', width: '200px', marginRight: '5px'} }}
							readOnly={readOnly}
						 />
						<KatottgButton onKatottgSelected={this.onKatottgSelected} 
							styles={{button: {}}}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'region'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ select: {width: '180px', marginRight: '20px'}}} 
						/>
						<FieldString instance={instance} path={'district'} parentField={parentField} plain={plain}
							styles={{ input: {flexGrow: '1', width: '120px', marginRight: '20px'} }}
							readOnly={this.readOnly}
						 />
						<FieldString instance={instance} path={'community'} parentField={parentField} plain={plain}
							styles={{ input: {flexGrow: '1', width: '120px'} }}
							readOnly={this.readOnly}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'city'} parentField={parentField} plain={plain}
							styles={{ input: {flexGrow: '1', width: '120px', marginRight: '20px'} }}
							readOnly={this.readOnly}
						 />
						<FieldString instance={instance} path={'place'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '150px'}}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldDecimal instance={instance} path={'latitude'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px', marginRight: '20px'}}}
						 />
						<FieldDecimal instance={instance} path={'longitude'} parentField={parentField} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px'}}}
						 />
					</div>
					<div style={{marginBottom: '15px'}}>
						<LabelField instance={instance} path={'comment'} parentField={parentField} />
						<FieldString  instance={instance} path={'comment'} parentField={parentField} plain={plain} 
							readOnly={readOnly}
							multiline={true} rows={4} cols={60}
							styleInput={{width: '98%'}} ignoreTitle={true}
						 />
					</div>
				</div>
			</div>
		)
	}
}

export default DivLocationList;